export const searchForParameters = (effect, searchTerm) => {
    let parameters = [];
    for (let p of effect._parameters) {
        let names = [];
        if (!p || !p.name) {
            continue;
        }
        if (p.context) {
            if (p.context.subDevice && p.context.subDevice.name) {
                names.push(p.context.subDevice.name.toLowerCase());
            }
            if (p.context.effect && p.context.effect.name) {
                names.push(p.context.effect.name.toLowerCase());
            }
            if (p.context.midiEffect && p.context.midiEffect.name) {
                names.push(p.context.midiEffect.name.toLowerCase());
            }
        }
        names.push(p.name.toLowerCase());
        if (names.some(n => n.includes(searchTerm.toLowerCase()))) {
            parameters.push(p);
        }
    }
    return parameters;
};
